"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.mustShowLicenceCode = exports.mayShowVideo = exports.mayShowUnderOffer = exports.mayShowStatusDescription = exports.mayShowStatementOfInformation = exports.mayShowMarketReview = exports.mayShowListing = exports.mayShowEnquiryForm = exports.mayShowContractRequestForm = exports.mayRequestInspection = exports.getOfficeLicenceCode = exports.getAgentLicenceCode = void 0;
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var isCurrentListing = statusCode => statusCode === 'CUR';
var mayShowEnquiryForm = statusCode => isCurrentListing(statusCode);
exports.mayShowEnquiryForm = mayShowEnquiryForm;
var mayShowStatementOfInformation = exports.mayShowStatementOfInformation = isCurrentListing;
var mayShowMarketReview = (countryCode, typeCode) => {
  var _context;
  return countryCode === 'AU' && (0, _indexOf.default)(_context = ['ALP', 'COM', 'BUS', 'CLR', 'LVS', 'LVW']).call(_context, typeCode) === -1;
};
exports.mayShowMarketReview = mayShowMarketReview;
var mayShowContractRequestForm = (statusCode, typeCode) => {
  var _context2;
  return statusCode === 'CUR' && (0, _indexOf.default)(_context2 = ['SAL', 'ALP', 'RUR', 'LVS']).call(_context2, typeCode) !== -1;
};
exports.mayShowContractRequestForm = mayShowContractRequestForm;
var mayRequestInspection = (statusCode, typeCode) => {
  var _context3;
  return !!(statusCode === 'CUR' && ~(0, _indexOf.default)(_context3 = ['BUS', 'COM', 'REN', 'RUR', 'SAL']).call(_context3, typeCode));
};
exports.mayRequestInspection = mayRequestInspection;
var mayShowStatusDescription = statusCode => statusCode !== 'CUR';
exports.mayShowStatusDescription = mayShowStatusDescription;
var mustShowLicenceCode = (countryCode, stateCode) => countryCode === 'NZ' || countryCode === 'AU' && stateCode === 'SA';
exports.mustShowLicenceCode = mustShowLicenceCode;
var getOfficeLicenceCode = (countryCode, stateCode, licenceCode) => countryCode === 'NZ' ? licenceCode : undefined;
exports.getOfficeLicenceCode = getOfficeLicenceCode;
var getAgentLicenceCode = (countryCode, stateCode, licenceCode) => {
  if (!mustShowLicenceCode(countryCode, stateCode)) {
    return undefined;
  }
  if (countryCode === 'NZ') {
    return 'Licensed REAA 2008';
  }
  return licenceCode;
};
exports.getAgentLicenceCode = getAgentLicenceCode;
var mayShowVideo = exports.mayShowVideo = isCurrentListing;
var anyIn = (a, b) => (0, _reduce.default)(a).call(a, (result, val) => {
  if (result) return result;
  return !!~(0, _indexOf.default)(b).call(b, val);
}, false);

/**
 * Confirm that a listing may be shown.  See RULES.md for a full description,
 * but in most cases only listings that match the site offices may be shown.
 */
var mayShowListing = (listingStatusCode, listingOrganisationId, listingMemberIds, organisationIds, memberIds, allowOtherOffices) => {
  // Listing belongs to a site in the office
  if (~(0, _indexOf.default)(organisationIds).call(organisationIds, listingOrganisationId)) return true;

  // Unless other offices are permitted, non matching listings are never shown
  if (!allowOtherOffices) return false;

  // Listing does not belong to a site in the office and it's current
  if (listingStatusCode === 'CUR') return false;
  return anyIn(listingMemberIds, memberIds);
};

/**
 * Under Offer status info should only be shown for current,
 * non-commercial lease listing,
 * non-NZ listings that are marked as under offer.
 */
exports.mayShowListing = mayShowListing;
var mayShowUnderOffer = (underOffer, statusCode, countryCode, subTypeCode, typeCode) => underOffer && statusCode === 'CUR' && countryCode !== 'NZ' && !(typeCode === 'COM' && subTypeCode === 'LSE');
exports.mayShowUnderOffer = mayShowUnderOffer;